// extracted by mini-css-extract-plugin
module.exports = {"label":"BirthDatePicker_label__2Sr5V","field":"BirthDatePicker_field__3Env8"};